import TemplateView from "../../../TemplateView"
import AccountInformation from "./AccountInformation"
import WorkSchedule from "./WorkSchedule"
import TimeTrackApprovalSetting from "./TimeTrackApprovalSetting"
import UserRates from "./UserRates"
import {MODE} from "../UserPanelContainer"
import $ from "jquery"
import Overtime from "./Overtime"
import {Feature, isEnabled} from "../../../features/index"
import {ValidationErrorsScrollClasses} from '../constants'
import {createInstance as createUserPanelModalAlert} from '../UserPanelModalAlert'
import WorkStatusesScheduleContainer from './workStatuses/components/WorkStatusesContainer'

export default class AccountSettings extends TemplateView
{
    constructor({
        wrapperId,
        mode,
        userGroupRow,
        timeZoneGroupRow,
        onInitialScheduleChanged= () => {},
        onWorkScheduleChanged = () => {},
        onDefaultWorkStatusesChanged = () => {},
        deleteWorkSchedule = () => {},
        addNewSchedule = () => {},
        refreshScrollCb = () => {},
        scrollToElement = ($el) => {},
        scrollToTop = () => {},
        restoreState = () => {},
    }) {
        super()
        this.updateOnInit = false
        this.accountSettingsId = wrapperId
        this.mode = mode
        this.userGroupRow = userGroupRow
        this.timeZoneGroupRow = timeZoneGroupRow
        this.restoreState = restoreState
        this.scrollToElement = scrollToElement
        this.scrollToTop = scrollToTop
        this.state = {
            showOvertime: isEnabled(Feature.OVR),
            showUserRates: false,
            updatingUserRates: false,
            loaded: false,
            approversList: [],
        }

        this.callbacks = {
            onInitialScheduleChanged,
            onWorkScheduleChanged,
            onDefaultWorkStatusesChanged,
            deleteWorkSchedule,
            addNewSchedule,
            refreshScrollCb,
        }

        this.onStatePropertyChanged('showUserRates', showUserRates => this._updateUserRatesSection(showUserRates))
        this.onStatePropertyChanged('updatingUserRates', updating => this.userRates.setState({updating}))
        this.onStatePropertyChanged('showOvertime', show => this.overtime.toggle(show))
        this.onStatePropertyChanged('approversList', approversList => this.timeTrackApprovalSetting.setState({
            approvers: approversList
        }))

        this.onStatePropertyChanged('loaded', loaded => {
            this.timeTrackApprovalSetting.setState({loaded : loaded})
            this.accountInformation.setState({loaded})
        })
    }

    templateHtml()
    {
        return "<div class='accountSettings panelTab'>" +
               "    <div class='accountInformation section <%=accountInformationScrollClass%>'/>" +
               "    <div class='timeTrackApproval section <%=timeTrackApprovalScrollClass%>'/>" +
               "    <div class='workScheduleAndOvertime section <%=workScheduleScrollClass%>'>" +
               "        <div class='sectionHeader'>" +
               "            <span id='<%=id%>_sectionHeaderPlaceholder'><%=header%></span>" +
               "            <span class='section_sync_icon' title='<%=syncWithOtherProduct%>'/>" +
               "        </div>" +
               "    </div>" +
               "    <div class='workStatusSchedule section <%=defaultWorkStatusPlanningScrollClass%>'>" +
               "    </div>" +
               "    <div class='userRates section <%=userRatesScrollClass%>'/>" +
               "</div>";
    }

    templateModel() {
        return {
            id: this.id,
            accountInformationScrollClass: ValidationErrorsScrollClasses.ACCOUNT_INFORMATION,
            timeTrackApprovalScrollClass: ValidationErrorsScrollClasses.TIME_TRACK_APPROVAL,
            workScheduleScrollClass: ValidationErrorsScrollClasses.WORK_SCHEDULE,
            defaultWorkStatusPlanningScrollClass: ValidationErrorsScrollClasses.DEFAULT_WORK_STATUS_PLANNING,
            userRatesScrollClass: ValidationErrorsScrollClasses.USER_RATES,
        }
    }

    messageKeys() {
        return {
            header: (this.state.showOvertime) ? 'userlist.userdata.schedule.work_schedule_and_overtime' : 'userlist.userdata.schedule.work_schedule',
            syncWithOtherProduct: 'user.add_edit.section_synchronized_with_other_product',
        }
    }

    afterRender()
    {
        super.afterRender();

        this.$userRates = this.find('.userRates')

        this.accountInformation = new AccountInformation({
            id: this.accountSettingsId,
            mode: this.mode,
            userGroupRow: this.userGroupRow,
            timeZoneGroupRow: this.timeZoneGroupRow,
            restoreState: this.restoreState,
            scrollTo: this.scrollToTop,
        }).init(this.find('.accountInformation'));
        this.timeTrackApprovalSetting = new TimeTrackApprovalSetting(this.find('.timeTrackApproval')).init();
        this.workSchedule = new WorkSchedule({
            id: this.accountSettingsId,
            mode: this.mode,
            scrollTo: this.scrollToElement,
            onInitialScheduleChanged: this.callbacks.onInitialScheduleChanged,
            onWorkScheduleChanged: this.callbacks.onWorkScheduleChanged,
            deleteWorkSchedule: this.callbacks.deleteWorkSchedule,
            addNewSchedule: this.callbacks.addNewSchedule,
            refreshScrollCb: this.callbacks.refreshScrollCb,
            subscribeSelectorOnScroll: (hideCb) => this._subscribeSelectorOnScroll(hideCb),
        }).init(this.find('.workScheduleAndOvertime'))

        this.overtime = new Overtime(this.find('.workScheduleAndOvertime')).init();
        this.overtime.toggle(this.state.showOvertime)

        this.workStatusSchedule = new WorkStatusesScheduleContainer({
            mode: this.mode,
            refreshScrollCb: this.callbacks.refreshScrollCb,
            onRemoteUpdate: this.callbacks.onDefaultWorkStatusesChanged
        }).init(this.find('.workStatusSchedule'))


        this.find('.workStatusSchedule').toggle(isEnabled(Feature.WSD))

        $(document).scroll(() => this.onScroll())

        if (this.mode === MODE.EDIT)
            createUserPanelModalAlert(this.getEl())
    }

    _subscribeSelectorOnScroll(hideOpenSelectorCallback) {
        this.hideOpenSelectorCallback = hideOpenSelectorCallback
    }

    onScroll() {
        if (this.hideOpenSelectorCallback)
            this.hideOpenSelectorCallback()
    }

    isShowUserRates(){
        return this.state.showUserRates
    }

    _updateUserRatesSection(showUserRates) {
        if (showUserRates) {
            this.userRates = new UserRates({
                id: this.accountSettingsId,
                mode: this.mode,
                scrollTo: this.scrollToElement,
                refreshScrollCb: this.callbacks.refreshScrollCb,
                subscribeSelectorOnScroll: (hideCb) => this._subscribeSelectorOnScroll(hideCb)
            }).init(this.$userRates);
            this.registerChildComponents(this.userRates)
        } else {
            this.$userRates.empty()
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/AccountSettings.js